import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions, Button}from "@material-ui/core";

const styles = theme => ({
    dialog: {
        padding: "18px 24px",
        boxSizing: "border-box",
        borderRadius: "2px",
        backgroundColor: theme.ModalBGColor,
        boxShadow: "2px 2px 4px black",
        width: 400,
        userSelect: 'none'
    },
    dialogTitle: {
        fontSize: 14,
        fontWeight: "600",
        lineHeight: "20px",
        color: theme.HeaderSelectedText,
        padding: 0
    },
    dialogContent: {
        fontSize: theme.textFontSize,
        color: theme.TextColor,
        overflow: "hidden",
        padding: "16px 0px"
    },
    button: {
        fontSize: 14,
        textTransform: "none",
        borderRadius: "2px",
        width: "100%",
        margin: 0,
    },
    dialogAction: {
        justifyContent: "space-between",
        margin: 0,
        '&$buttonDialogAction': {
            paddingBottom: 0,
            paddingRight: 0
        }
    },
    buttonDialogAction: {
        margin: 0,
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between'
    }
});

const ShowingInProgressPopup = props => {
    const { classes,anchorPointsInfo }=  props;
    return (
        <Dialog
        open={true}
        aria-labelledby="ShowingInProgressPopup-title"
        classes = {{paper: classes.dialog}}
        maxWidth= 'sm'>
        <DialogTitle id="ShowingInProgressPopup-title" classes={{root: classes.dialogTitle}} disableTypography >
          {anchorPointsInfo? `Update `: `Add `} anchor point in progress
        </DialogTitle>
        <DialogContent  classes={{root:classes.dialogContent}}>
            <Grid container spacing={24}>
                <Grid item xs={12} classes={{root: classes.message}}>
                {anchorPointsInfo? `Update `: `Add New`} anchor point in progress, Please complete it first.
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions classes={{root: classes.dialogAction}}>
            <Grid container spacing={24}>
                <Grid item xs={8}></Grid>
                <Grid item xs={4} classes={{item: classes.buttonDialogAction}}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        disableRipple
                        className={classes.button}
                        onClick={props.onClose}>
                            ok
                    </Button>
                </Grid>
            </Grid>
    </DialogActions>
    </Dialog>
    )
}

export default withStyles(styles)(ShowingInProgressPopup);